export class CustomHighlights {
  constructor (app) {
    this.app = app
    this.toolbarButtonElement = document.getElementById('customHighlight')
    this.highlights = []
    this.loaded = false
    this.selectStartedOnPage = -1
    this.activeClass = 'toggled'
    this.selectedHighlightId = null

    this._bindEvents()
  }

  _bindEvents () {
    this.toolbarButtonElement.addEventListener('click', (evt) => this._onClick(evt))
    this.app.eventBus.on('documentloaded', (evt) => this._onDocumentLoaded(evt))
    this.app.eventBus.on('pagerendered', (evt) => this._onPageRendered(evt))
    document.addEventListener('click', (evt) => this._onDocumentClick(evt))
    // document.addEventListener('selectstart', (evt) => this._onSelectStart(evt))
    // document.addEventListener('selectionchange', (evt) => this._onSelectionChange(evt))
  }

  _onClick () {
    if (!this.loaded) {
      return
    }

    if (this.selectedHighlightId) {
      this._deleteHighlight(this.selectedHighlightId)
      this.selectedHighlightId = null
      this.toolbarButtonElement.classList.remove(this.activeClass)
      return
    }

    if (!window.getSelection().rangeCount) {
      return
    }

    const selection = this._getSelectionRects()

    this.app.api.addHighlight(selection).then(stored => {
      this.highlights.push(stored)
      this._renderRects(stored)
      // this._clearSelection()
    }).catch(err => {
      console.error(err)
    })
  }

  _onDocumentLoaded () {
    this.loaded = true
    if (this.app.api.operating()) {
      this.app.api.getHighlights().then(highlights => {
        this.highlights = [...highlights]
        const currentPageIndex = this.app.pdfViewer.currentPageNumber - 1;
        this._renderRectsByPage(currentPageIndex)
      })
      this.toolbarButtonElement.classList.remove('hidden')
    } else {
      this.toolbarButtonElement.classList.add('hidden')
    }
  }

  _onPageRendered (evt) {
    const renderedPageIdx = evt.pageNumber - 1
    this._renderRectsByPage(renderedPageIdx)
  }

  _onDocumentClick (evt) {
    if (evt.target.classList.contains('highlight-rect')) {
      return
    }

    if (evt.target.id === this.toolbarButtonElement.id) {
      return
    }

    this._unselectSelectedHighlight()
  }

  _renderRectsByPage (pageIdx) {
    this.highlights.forEach(hl => {
      if (hl.page === pageIdx) {
        this._renderRects(hl)
      }
    })
  }

  // _onSelectStart () {
  //   console.log('started')
  //   this.selectStartedOnPage = this.app.pdfViewer.currentPageNumber
  // }

  // _onSelectionChange () {
  //   console.log('ended')
  //   const page = this.app.pdfViewer.currentPageNumber
  //   if (page != this.selectStartedOnPage) {
  //     this._clearSelection()
  //     console.log('clearing')
  //   }
  // }

  _getSelectionRects () {
    const pageIndex = this.app.pdfViewer.currentPageNumber - 1;
    const page = this.app.pdfViewer.getPageView(pageIndex);
    const pageRect = page.canvas.getClientRects()[0];
    const selectionRects = [...window.getSelection().getRangeAt(0).getClientRects()];
    const viewport = page.viewport;
    const selected = selectionRects.map(function (r) {
      return viewport.convertToPdfPoint(r.left - pageRect.x, r.top - pageRect.y).concat(
        viewport.convertToPdfPoint(r.right - pageRect.x, r.bottom - pageRect.y));
    });

    return {page: pageIndex, coords: selected};
  }

  // _clearSelection () {
  //   if (window.getSelection) {
  //     if (window.getSelection().empty) {
  //       window.getSelection().empty();
  //     } else if (window.getSelection().removeAllRanges) {
  //       window.getSelection().removeAllRanges();
  //     }
  //   } else if (document.selection) {
  //     document.selection.empty();
  //   }
  // }

  _renderRects (selection) {
    const pageIndex = selection.page;
    const page = this.app.pdfViewer.getPageView(pageIndex);
    const pageElement = page.div; //.canvas.parentElement;
    const viewport = page.viewport;
    selection.coords.forEach((rect) => {
      const bounds = viewport.convertToViewportRectangle(rect);
      const el = document.createElement('div');
      el.addEventListener('click', evt => {
        evt.preventDefault()
        this._unselectSelectedHighlight()
        this._selectHighlight(selection.id)
      })
      el.classList.add('highlight-rect')
      el.setAttribute('data-highlight-id', selection.id)
      el.setAttribute('style',
        'left:' + Math.min(bounds[0], bounds[2]) + 'px;'
        + 'top:' + Math.min(bounds[1], bounds[3]) + 'px;'
        + 'width:' + Math.abs(bounds[0] - bounds[2]) + 'px;'
        + 'height:' + Math.abs(bounds[1] - bounds[3]) + 'px;');
      pageElement.querySelector(".textLayer").appendChild(el);
    });
  }

  _selectHighlight (highlightId) {
    const elementsToSelect = document.querySelectorAll(
      `.highlight-rect[data-highlight-id="${highlightId}"]`
    )

    elementsToSelect.forEach(highlightRectEl => {
      highlightRectEl.classList.add('selected')
    })

    this.selectedHighlightId = highlightId
    this.toolbarButtonElement.classList.add(this.activeClass)
  }

  _unselectSelectedHighlight () {
    const selectedElements = document.querySelectorAll('.highlight-rect.selected')

    selectedElements.forEach(highlightRectEl => {
      highlightRectEl.classList.remove('selected')
    })

    this.selectedHighlightId = null
    this.toolbarButtonElement.classList.remove(this.activeClass)
  }

  _deleteHighlight (highlightId) {
    this.app.api.deleteHighlight(highlightId).then(() => {
      const elementsToSelect = document.querySelectorAll(
        `.highlight-rect[data-highlight-id="${highlightId}"]`
      )

      elementsToSelect.forEach(highlightRectEl => {
        highlightRectEl.remove()
      })
    })
  }
}
